<div class="select-parts-modal">
	<!-- Header -->
	<div class="modal-header">
		<h5 class="modal-title">{{ 'serviceLibrary.selectParts.title' | transloco }}</h5>
		<button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="onCancel()">
			<i class="ph ph-x"></i>
		</button>
	</div>

	<!-- Body -->
	<div class="modal-body">
		<!-- Search -->
		<div class="search-wrapper">
			<i class="ph ph-magnifying-glass search-icon"></i>
			<input
				type="text"
				class="search-input"
				[placeholder]="'serviceLibrary.selectParts.searchPlaceholder' | transloco"
				[(ngModel)]="searchTerm" />
		</div>

		<!-- Parts list -->
		<div class="parts-scroll">
			@for (part of filteredParts; track part.id) {
				<label class="part-item" (click)="$event.stopPropagation()">
					<input
						type="checkbox"
						class="part-checkbox"
						[checked]="isPartSelected(part.id)"
						(click)="$event.stopPropagation()"
						(change)="togglePart(part.id)" />
						<span class="part-label">{{ part.name }}</span>
				</label>
			}

			@if (!filteredParts.length) {
				<div class="no-results">{{ 'serviceLibrary.selectParts.noPartsFound' | transloco }}</div>
			}
		</div>
	</div>

	<!-- Footer -->
	<div class="modal-footer">
		<button type="button" class="cancel-btn" (click)="onCancel()">{{ 'common.cancel' | transloco }}</button>
		<button type="button" class="add-btn" (click)="onAddParts()">
			{{ 'maintenanceOverview.modals.selectParts.addPartsButton' | transloco }}
			@if (selectedCount > 0) {
				<span class="selected-badge">{{ selectedCount }}</span>
			}
		</button>
	</div>
</div>